import { useMutation, useQueryClient } from '@tanstack/react-query';
import { formatCount } from '@/utils/number';
import { failPcmpAccountsBatch } from '../api/pcmpAccounts.api';
import type {
  PcmpAccountsBatchFailPayload,
  PcmpAccountsBatchFailResult,
} from '../types/pcmpAccounts.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

export function useFailPcmpAccountsBatch(
  batchNo: number,
  onSuccess: (result: PcmpAccountsBatchFailResult) => void,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpAccountsBatchFailPayload) => failPcmpAccountsBatch(batchNo, payload),
    ...pcmpActionCallbacks<PcmpAccountsBatchFailResult>(
      queryClient,
      (result) => `${formatCount(result.failed.length, 'proposal')} marked Disbursement Failed`,
      onSuccess,
    ),
  });
}
